// // src/pages/VerifyEmailPage.jsx
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
// import { doc, updateDoc } from "firebase/firestore";
// import { db } from "../utils/firebase";

// export default function VerifyEmailPage() {
//   const { user, logout, resendVerificationEmail } = useAuth();
//   const navigate = useNavigate();
//   const [resending, setResending] = useState(false);
//   const [resendSuccess, setResendSuccess] = useState(false);
//   const [resendError, setResendError] = useState("");
//   const [checking, setChecking] = useState(false);

//   // Auto-check every 5 seconds if email has been verified
//   useEffect(() => {
//     if (!user) return;

//     const interval = setInterval(async () => {
//       try {
//         await user.reload();
//         if (user.emailVerified) {
//           await updateDoc(doc(db, "users", user.uid), {
//             emailVerified: true,
//           });
//           clearInterval(interval);
//           navigate("/dashboard");
//         }
//       } catch (err) {
//         console.error("Email check error:", err);
//       }
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [user, navigate]);

//   async function handleResend() {
//     setResendError("");
//     setResendSuccess(false);
//     setResending(true);
//     try {
//       await resendVerificationEmail();
//       setResendSuccess(true);
//       setTimeout(() => setResendSuccess(false), 5000);
//     } catch (err) {
//       if (err.code === "auth/too-many-requests") {
//         setResendError("Too many attempts. Please wait a few minutes.");
//       } else {
//         setResendError("Failed to resend. Please try again.");
//       }
//     }
//     setResending(false);
//   }

//   async function handleCheckNow() {
//     setChecking(true);
//     try {
//       await user.reload();
//       if (user.emailVerified) {
//         await updateDoc(doc(db, "users", user.uid), {
//           emailVerified: true,
//         });
//         navigate("/dashboard");
//       } else {
//         setResendError("Email not verified yet. Please check your inbox.");
//         setTimeout(() => setResendError(""), 4000);
//       }
//     } catch (err) {
//       console.error("Check error:", err);
//     }
//     setChecking(false);
//   }

//   async function handleLogout() {
//     await logout();
//     navigate("/login");
//   }

//   return (
//     <div style={{ minHeight: "100vh", background: "var(--gray-50)", display: "flex", flexDirection: "column" }}>

//       {/* NAV */}
//       <nav style={{ borderBottom: "1px solid var(--gray-200)", padding: "0 32px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff" }}>
//         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <div style={{ width: 30, height: 30, background: "var(--blue)", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <span style={{ color: "#fff", fontSize: 14 }}>📄</span>
//           </div>
//           <span style={{ fontWeight: 700, fontSize: 16, color: "var(--gray-900)" }}>
//             ResumeScore<span style={{ color: "var(--blue)" }}>AI</span>
//           </span>
//         </div>
//         <button
//           className="btn btn-outline"
//           style={{ fontSize: 13, padding: "6px 14px" }}
//           onClick={handleLogout}
//         >
//           Log Out
//         </button>
//       </nav>

//       {/* CONTENT */}
//       <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 16px" }}>
//         <div style={{ width: "100%", maxWidth: 460 }}>
//           <div className="card" style={{ padding: "40px 36px", textAlign: "center" }}>

//             {/* Icon */}
//             <div style={{ width: 72, height: 72, borderRadius: "50%", background: "var(--blue-light)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px", fontSize: 32 }}>
//               📧
//             </div>

//             <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 10, letterSpacing: "-0.02em" }}>
//               Verify your email
//             </h1>

//             <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 8, lineHeight: 1.7 }}>
//               We sent a verification link to:
//             </p>

//             <div style={{ background: "var(--blue-light)", color: "var(--blue)", fontSize: 14, fontWeight: 600, padding: "10px 16px", borderRadius: 8, marginBottom: 20 }}>
//               {user?.email}
//             </div>

//             <p style={{ fontSize: 13, color: "var(--gray-500)", marginBottom: 28, lineHeight: 1.7 }}>
//               Click the link in the email to verify your account.
//               This page will automatically redirect you once verified.
//               Please also check your <strong>spam folder</strong>.
//             </p>

//             {/* Auto-checking indicator */}
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 24, fontSize: 13, color: "var(--gray-400)" }}>
//               <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#3B6D11", animation: "pulse 2s infinite" }} />
//               Checking automatically every 5 seconds...
//             </div>

//             {/* Success message */}
//             {resendSuccess && (
//               <div style={{ background: "#EAF3DE", color: "#3B6D11", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16, border: "1px solid #C0DD97" }}>
//                 ✅ Verification email sent! Check your inbox.
//               </div>
//             )}

//             {/* Error message */}
//             {resendError && (
//               <div style={{ background: "#FCEBEB", color: "#A32D2D", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16, border: "1px solid #f0a0a0" }}>
//                 {resendError}
//               </div>
//             )}

//             {/* Actions */}
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               <button
//                 className="btn btn-primary btn-full btn-lg"
//                 onClick={handleCheckNow}
//                 disabled={checking}
//               >
//                 {checking
//                   ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Checking...</>
//                   : "✓ I've Verified My Email"
//                 }
//               </button>

//               <button
//                 className="btn btn-outline btn-full"
//                 onClick={handleResend}
//                 disabled={resending}
//               >
//                 {resending
//                   ? <><span className="spinner spinner-dark" style={{ width: 14, height: 14, borderTopColor: "var(--blue)" }} /> Sending...</>
//                   : "Resend Verification Email"
//                 }
//               </button>
//             </div>

//             <p style={{ fontSize: 12, color: "var(--gray-400)", marginTop: 20, lineHeight: 1.6 }}>
//               Wrong email?{" "}
//               <button
//                 onClick={handleLogout}
//                 style={{ background: "none", border: "none", color: "var(--blue)", cursor: "pointer", fontSize: 12, padding: 0, fontWeight: 500 }}
//               >
//                 Log out
//               </button>
//               {" "}and sign up with the correct email.
//             </p>

//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes pulse {
//           0%, 100% { opacity: 1; }
//           50% { opacity: 0.3; }
//         }
//       `}</style>
//     </div>
//   );
// }


// new code
// src/pages/VerifyEmailPage.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../utils/firebase";

export default function VerifyEmailPage() {
  const { user, logout, resendVerificationEmail } = useAuth();
  const navigate = useNavigate();
  const [resending,     setResending]     = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [resendError,   setResendError]   = useState("");
  const [checking,      setChecking]      = useState(false);

  // ── Redirect if already verified (e.g. user refreshes after verifying) ──
  useEffect(() => {
    if (user?.emailVerified) navigate("/dashboard");
  }, [user, navigate]);

  // ── Auto-check every 5 seconds ──
  useEffect(() => {
    if (!user) return;
    const interval = setInterval(async () => {
      try {
        await user.reload();
        if (user.emailVerified) {
          // Persist verified flag to Firestore — best-effort
          try {
            await updateDoc(doc(db, "users", user.uid), { emailVerified: true });
          } catch (_) { /* non-critical */ }
          clearInterval(interval);
          navigate("/dashboard");
        }
      } catch (err) {
        console.error("Email check error:", err);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [user, navigate]);

  async function handleResend() {
    setResendError("");
    setResendSuccess(false);
    setResending(true);
    try {
      await resendVerificationEmail();
      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 30000); // show for 30s not 5s
    } catch (err) {
      setResendError(
        err.code === "auth/too-many-requests"
          ? "Too many attempts — please wait a few minutes before trying again."
          : "Failed to resend. Please try again."
      );
    }
    setResending(false);
  }

  async function handleCheckNow() {
    setChecking(true);
    setResendError("");
    try {
      await user.reload();
      if (user.emailVerified) {
        try {
          await updateDoc(doc(db, "users", user.uid), { emailVerified: true });
        } catch (_) { /* non-critical */ }
        navigate("/dashboard");
      } else {
        setResendError("Email not verified yet — check your inbox and click the link.");
        setTimeout(() => setResendError(""), 5000);
      }
    } catch (err) {
      console.error("Check error:", err);
      setResendError("Could not check status. Please try again.");
    }
    setChecking(false);
  }

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  return (
    <div style={{ minHeight: "100vh", background: "var(--gray-50)", display: "flex", flexDirection: "column" }}>

      {/* ── NAV ── */}
      <nav style={{ borderBottom: "1px solid var(--gray-200)", padding: "0 32px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 30, height: 30, background: "#2563eb", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: "#fff", fontWeight: 800, fontSize: 14 }}>R</span>
          </div>
          <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>
            ResumeScore<span style={{ color: "#2563eb" }}>AI</span>
          </span>
        </div>
        <button
          className="btn btn-outline"
          style={{ fontSize: 13, padding: "6px 14px" }}
          onClick={handleLogout}
        >
          Log out
        </button>
      </nav>

      {/* ── CONTENT ── */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 16px" }}>
        <div style={{ width: "100%", maxWidth: 460 }}>
          <div className="card" style={{ padding: "40px 36px", textAlign: "center" }}>

            {/* Icon — SVG instead of emoji */}
            <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#eff6ff", border: "1px solid #bfdbfe", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
            </div>

            <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 10, letterSpacing: "-0.02em", color: "#0f172a" }}>
              Verify your email
            </h1>

            <p style={{ fontSize: 14, color: "#64748b", marginBottom: 8, lineHeight: 1.7 }}>
              We sent a verification link to:
            </p>

            <div style={{ background: "#eff6ff", color: "#2563eb", fontSize: 14, fontWeight: 600, padding: "10px 16px", borderRadius: 8, marginBottom: 20 }}>
              {user?.email}
            </div>

            {/* Steps */}
            <div style={{ background: "#f8fafc", borderRadius: 12, padding: "16px", marginBottom: 20, textAlign: "left", border: "1px solid #e2e8f0" }}>
              {[
                "Open the email from ResumeScoreAI",
                'Click "Verify Email Address"',
                "You'll be redirected here automatically",
              ].map((step, i) => (
                <div key={i} style={{ display: "flex", gap: 10, marginBottom: i < 2 ? 8 : 0 }}>
                  <span style={{ width: 20, height: 20, borderRadius: "50%", background: "#dbeafe", color: "#2563eb", fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}>
                    {i + 1}
                  </span>
                  <span style={{ fontSize: 13, color: "#475569", lineHeight: 1.6 }}>{step}</span>
                </div>
              ))}
            </div>

            <p style={{ fontSize: 13, color: "#94a3b8", marginBottom: 24, lineHeight: 1.7 }}>
              Can't find it? Check your <strong style={{ color: "#64748b" }}>spam or junk folder</strong>.
            </p>

            {/* Auto-checking indicator */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 24, fontSize: 12, color: "#94a3b8" }}>
              <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#059669", animation: "pulse 2s infinite" }} />
              Checking automatically every 5 seconds...
            </div>

            {/* Success */}
            {resendSuccess && (
              <div style={{ background: "#f0fdf4", color: "#059669", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16, border: "1px solid #bbf7d0" }}>
                ✓ Verification email sent — check your inbox
              </div>
            )}

            {/* Error */}
            {resendError && (
              <div style={{ background: "#fef2f2", color: "#dc2626", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 16, border: "1px solid #fecaca" }}>
                {resendError}
              </div>
            )}

            {/* Actions */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <button
                className="btn btn-primary btn-full btn-lg"
                onClick={handleCheckNow}
                disabled={checking}
              >
                {checking
                  ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Checking...</>
                  : "I've verified my email →"}
              </button>

              <button
                className="btn btn-outline btn-full"
                onClick={handleResend}
                disabled={resending || resendSuccess}
              >
                {resending
                  ? <><span className="spinner spinner-dark" style={{ width: 14, height: 14, borderTopColor: "#2563eb" }} /> Sending...</>
                  : resendSuccess
                  ? "✓ Email sent"
                  : "Resend verification email"}
              </button>
            </div>

            <p style={{ fontSize: 12, color: "#94a3b8", marginTop: 20, lineHeight: 1.6 }}>
              Wrong email?{" "}
              <button
                onClick={handleLogout}
                style={{ background: "none", border: "none", color: "#2563eb", cursor: "pointer", fontSize: 12, padding: 0, fontWeight: 500 }}
              >
                Log out
              </button>
              {" "}and sign up with the correct one.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
}
